import { ComponentType, useMemo } from "react";

import { IntlShape } from "react-intl";

import { Adjust, Finalize, Setup } from "../steps";
import StepProps from "../type/StepProps";

const useSteps = (intl: IntlShape): { content: ComponentType<StepProps>; title: string }[] =>
  useMemo(
    () => [
      {
        content: Setup,
        title: intl.formatMessage({
          id: "activities.calendarView.routeBuilder.steps.setupRoute",
          defaultMessage: "Set up route",
          description: "First step title in Route Builder in Activity Calendar view",
        }),
      },
      {
        content: Adjust,
        title: intl.formatMessage({
          id: "activities.calendarView.routeBuilder.steps.adjustSteps",
          defaultMessage: "Adjust stops",
          description: "Second step title in Route Builder in Activity Calendar view",
        }),
      },
      {
        content: Finalize,
        title: intl.formatMessage({
          id: "activities.calendarView.routeBuilder.steps.finalize",
          defaultMessage: "Finalize",
          description: "Last step title in Route Builder in Activity Calendar view",
        }),
      },
    ],
    [intl]
  );

export default useSteps;
